define([
    "dojo/_base/declare",
    "csi",
    "csi/action/Controller",
    "csi/config",
    "csi/xml",
    "csi/xml/Query"
], function(declare,csi,Controller,config,xml,Query) {

    return declare(Controller, {

        applyActionFilters: function(/*csi.view.Widget*/view) {
            if (config.hasSubtype("ApparelBOM")) {
                var q = new Query();
                q.RefAttr("ThemeBOMType", xml.OP_NOT_EQUALS, csi.EMPTY_URL);
                view.relRoot.addQuery(q);
            }

            this.inherited(arguments);
        }

    });
});